import script from "./ClientsView.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientsView.vue?vue&type=script&setup=true&lang=js"

import "./ClientsView.vue?vue&type=style&index=0&id=6c376903&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c376903"]])

export default __exports__